export const EVENT_TYPES = {
  APP_VIEW: 'app_view',
  SITE_FILTER: 'site_filter',
  TAB_CLICK: 'tab_click',
}
export const REFERRER_TYPES = {
  APPS: 'apps',
  SIDEBAR: 'sidebar',
}
